import React from "react";
import CampaignIcon from "@mui/icons-material/Campaign";
import DoneIcon from "@mui/icons-material/Done";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import EstadoEntradaBadge from "../components/ui/EstadoEntradaBadge";
import { formatFechaHora } from "../utils/formatters";
import { crearAccion } from "./columns";

/**
 * Definiciones de columnas para el DataGrid de entradas del gestor
 */

const formatearFecha = (params) => formatFechaHora(params.value);

/**
 * Genera las columnas del DataGrid de entradas de cola
 * @param {Object} params
 * @param {Function} params.onLlamar - Llama a la entrada (recibe la fila completa)
 * @param {Function} params.onFinalizar - Abre la finalización de la entrada
 * @param {Function} params.onSaltar - Salta la entrada
 * @param {number|string|null} [params.procesandoId] - Id de la entrada con una acción en vuelo
 * @param {boolean} [params.bloqueado] - Deshabilita todas las acciones (carga o acción en curso)
 * @returns {Array} Definiciones de columnas para el DataGrid
 */
export const generateEntradaColumns = ({ onLlamar, onFinalizar, onSaltar, procesandoId = null, bloqueado = false }) => [
    { field: "id", headerName: "ID", flex: 0.3, editable: false },
    { field: "numero", headerName: "Número", flex: 0.8, editable: false },
    {
        field: "estado",
        headerName: "Estado",
        flex: 1,
        editable: false,
        renderCell: (params) => <EstadoEntradaBadge estado={params.value} />,
    },
    { field: "creado", headerName: "Creado", flex: 1, editable: false, valueFormatter: formatearFecha },
    { field: "modificado", headerName: "Modificado", flex: 1, editable: false, valueFormatter: formatearFecha },
    {
        field: "actions",
        type: "actions",
        headerName: "Acciones",
        width: 150,
        // Todas las acciones están disponibles en cualquier estado, como en el legacy
        getActions: ({ row }) => {
            const deshabilitada = bloqueado || procesandoId === row.id;
            return [
                crearAccion("llamar", "Llamar", <CampaignIcon />, onLlamar, row, deshabilitada),
                crearAccion("finalizar", "Finalizar", <DoneIcon />, onFinalizar, row, deshabilitada),
                crearAccion("saltar", "Saltar", <SkipNextIcon />, onSaltar, row, deshabilitada),
            ];
        },
    },
];
